<template>
  <div class="course-detail-group-buy-girdle">
    <div class="group-buy-info-wrapper">
      <!-- 活动价格 -->
      <div class="activity-price-info">
        <div class="activity-price-info-container">
          <div class="price-container">
            <div class="activity-tag font-bold">
              Group Buy
            </div>
            <div class="price-text">
              <span class="sell-price font-bold"><slot name="activity-price" /></span><span class="org-price font-medium"><slot name="org-price" /></span>
            </div>
          </div>
        </div>
      </div>
      <slot name="group-status" />
      <!-- 已开团列表 -->
      <div v-if="showGroupList && Array.isArray(groupList) && groupList.length > 0"
           class="group-list-wrapper"
           :class="{'only-one': Array.isArray(groupList) && groupList.length == 1}"
      >
        <div class="group-list-container">
          <!-- 拼团卡片 -->
          <div v-for="(group, index) in groupList" :key="`${index}-${group.groupId}`"
               v-sa-track="[{type: 'visually', event: 'group_card_show', data: getTrackData('visually', group)}]"
               class="group-item-card"
               :class="{'focused-1': index == focusedIndexs[0],
                        'focused-2': index == focusedIndexs[1],
                        'prev': prevIndexs.indexOf(index) >= 0,
                        'next': prevIndexs.indexOf(index) >= 0}"
          >
            <div class="card-header">
              <div class="card-header-container">
                <div class="avatar-list">
                  <template v-if="group.groupMemberList && Array.isArray(group.groupMemberList) && group.groupMemberList.length>0">
                    <img v-for="member in group.groupMemberList.length > 3 ? group.groupMemberList.slice(0,3) : group.groupMemberList" :key="member.studentId" class="avatar avatar-img" v-lazy-load :data-src="member.avatar" alt="">
                  </template>

                  <div v-for="val in getPlaceholderImgNumber(group.groupSize, group.groupMemberList)" :key="`placeholder-${val}`" class="avatar avatar-img-placeholder" />
                </div>
                <div v-if="getRemainMembers(group.groupSize, group.groupMemberList) > 0" class="group-info font-medium">
                  <div class="group-status">
                    {{ getRemainMembers(group.groupSize, group.groupMemberList) }} more people
                  </div>
                  <div class="desc-text">
                    needed to complete Group Buy
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="count-down-container">
                <CountDown v-if="group.remainingTime > 0" :auto-start="true" :countdown="group.remainingTime" @countdown-over="refresh">
                  <template v-slot:countdown-container="slotProps">
                    <div class="count-down-template font-semibold">
                      <template v-if="Number(slotProps.days)>0">
                        <div class="timer-unit-item">
                          <div class="timer-value">
                            {{ slotProps.days }}
                          </div>
                          <div class="unit-tag">
                            <span>DAY</span>
                          </div>
                        </div>
                        <div class="colon-symbol">
                          <span class="placeholder-bg" />
                        </div>
                      </template>
                      <div class="timer-unit-item">
                        <div class="timer-value">
                          {{ slotProps.hours }}
                        </div>
                        <div class="unit-tag">
                          <span>HOUR</span>
                        </div>
                      </div>
                      <div class="colon-symbol">
                        <span class="placeholder-bg" />
                      </div>
                      <div class="timer-unit-item">
                        <div class="timer-value">
                          {{ slotProps.mins }}
                        </div>
                        <div class="unit-tag">
                          <span>MIN</span>
                        </div>
                      </div>
                      <div class="colon-symbol">
                        <span class="placeholder-bg" />
                      </div>
                      <div class="timer-unit-item">
                        <div class="timer-value">
                          {{ slotProps.secs }}
                        </div>
                        <div class="unit-tag">
                          <span>SEC</span>
                        </div>
                      </div>
                    </div>
                  </template>
                </CountDown>
              </div>
              <div
                v-sa-track="[{type: 'click', event: 'group_card_click', data: getTrackData('click', group)}]"
                class="button button-default button-small btn-join-group"
                @click="joinInGroupHandler(group)"
              >
                <span class="font-semibold">Join Now</span><span class="icon-container font-medium"><i class="iconfont icon-reschedule" /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 装饰条 -->
      <div class="link-rope left">
        <div class="rope" />
      </div>
      <div class="link-rope right">
        <div class="rope" />
      </div>
    </div>

    <!-- 活动说明模块 -->
    <div class="course-detail-section-card group-buy-instruction-wrapper">
      <div class="card-header">
        <div class="card-header-wrapper">
          <div class="card-header-container">
            <div class="card-title font-medium">
              Promotions
            </div>
            <div class="card-header-right clickable" @click="showProgress">
              <span class="card-desc font-medium">Group Buy in Progress</span><span class="btn-icon-to-detail"><i class="iconfont icon-reschedule icon-to-detail" /></span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="promotions-detail">
          <div class="step-guide-item">
            <p class="tag-item font-medium">
              Create a Group
            </p>
          </div>
          <div class="step-guide-item">
            <p class="tag-item font-medium">
              Invite friends to join
            </p>
          </div>
          <div class="step-guide-item">
            <p class="tag-item font-medium">
              Group Buy will be completed when group is full
            </p>
          </div>
        </div>
        <div class="group-buy-tip-text font-medium">
          Payments will be refunded automatically if failed to complete group buy
        </div>
      </div>
    </div>
    <GroupBuyDesc ref="GroupBuyDesc" />
  </div>
</template>

<script>
import CountDown from 'components/common/CountDown';
import GroupBuyDesc from 'components/groupBuy/GroupBuyDesc';

export default {
  components: { CountDown, GroupBuyDesc },
  props: {
    fromType: {
      type: String,
      default: '',
    },
    classId: {
      type: Number,
      default: 0,
    },
    activityInfo: {
      default: () => ({}),
      type: Object,
    },
    showGroupList: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      focusedIndexs: [0, 1],
      prevIndexs: [],
      nextIndexs: [],
      switchTimer: null,
      autoSwitch: true,
    }
  },
  computed: {
    groupBuyData() {
      const groupData = JSON.parse(this.activityInfo.activityParam) || {}
      return groupData
    },
    groupList() {
      return this.groupBuyData.groupList || []
    },
    groupListLen() {
      return this.groupBuyData.groupList.length || 0
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.groupListLen <= 2) return
      this.switchAuto()
    })
  },
  beforeDestroy() {
    clearInterval(this.switchTimer)
  },
  methods: {
    // 说明
    showProgress() {
      this.$refs.GroupBuyDesc.openDialog()
    },
    // 参团
    async joinInGroupHandler(group) {
      this.$emit('join-in-group', group)
    },
    // 计算剩余可参团人数
    getRemainMembers(size, memberList) {
      if (!size || !Array.isArray(memberList)) return 0
      const members = memberList.length
      if (size <= members) return 0
      return Number(size) - Number(members)
    },
    // 计算头像占位图展示数量
    getPlaceholderImgNumber(size, memberList) {
      if (!size || !Array.isArray(memberList)) return 3
      let result = 0
      if (size >= 3) {
        result = 3 - memberList.length > 0 ? 3 - memberList.length : 0
      }
      if (size === 2) {
        result = 2 - memberList.length > 0 ? 2 - memberList.length : 0
      }
      if (size === 1) {
        result = memberList.length >= 1 ? 0 : 1
      }
      return result
    },
    switchAuto() {
      clearInterval(this.switchTimer)
      if (!this.autoSwitch) return
      this.switchTimer = setInterval(this.calcCurrIndex, 5000)
    },
    calcCurrIndex() {
      const len = this.groupListLen
      this.prevIndexs = this.focusedIndexs
      this.focusedIndexs = this.focusedIndexs.map((item) => (item + 2) % len)
      this.nextIndexs = this.focusedIndexs.map((item) => (item + 2) % len)
      console.log('this.prevIndexs', this.prevIndexs)
      console.log('this.focusedIndexs', this.focusedIndexs)
      console.log('this.nextIndexs', this.nextIndexs)
    },
    getTrackData(type, group) {
      const sourceMap = {
        'activity-detail': '参团详情页',
        'courses-detail': '班级详情页',
      }
      const data = {
        activity_id: this.activityInfo.activityId,
        group_id: group.groupId,
        class_id: this.classId,
        previous_source: sourceMap[this.fromType],
      }
      if (type === 'click') {
        data.residual_num = this.getRemainMembers(group.groupSize, group.groupMemberList)
      }
      return data
    },
    // 刷新数据
    refresh() {
      this.$emit('refresh')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../card-section.scss';
@import '../activity-price.scss';

.course-detail-group-buy-girdle {
  margin: 0 0 10px;

  .group-buy-info-wrapper {
    position: relative;
    margin-bottom: 10px;
    padding-bottom: 20px;
    border-radius: 10px;
    background: var(--txt-color-link3);

    .group-list-wrapper {
      position: relative;
      padding: 0 20px;
      height: 292px;
      box-sizing: border-box;
      overflow: hidden;

      &.only-one {
        height: 130px;
      }
    }
  }

  .group-item-card {
    position: absolute;
    top: 292px;
    left: 20px;
    right: 20px;
    margin: 0 auto;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.5s linear;
    z-index: 3;
    opacity: 0;
    visibility: hidden;

    &.prev {
      top: -146px;
      z-index: 2;
    }

    &.next {
      top: 292px;
      z-index: 2;
    }

    &.focused-1 {
      top: 0;
      opacity: 1;
      visibility: visible;
    }

    &.focused-2 {
      top: 146px;
      opacity: 1;
      visibility: visible;
    }

    .card-header {
      position: relative;
      padding: 12px;
      background: var(--txt-color-link);

      &::before {
        content: '';
        position: absolute;
        top: 0;
        width: 100%;
        bottom: 0;
        background: repeating-linear-gradient(80deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 5%, transparent 5%, transparent, 10%, rgba(255, 255, 255, 0.08) 10%);
      }

      .card-header-container {
        position: relative;
        display: flex;
        z-index: 1;
      }

      .avatar-list {
        display: flex;
        margin-right: 12px;
        width: 68px;

        .avatar {
          position: relative;
          flex-shrink: 0;
          margin-left: -26px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          box-sizing: border-box;

          &:first-child {
            margin: 0;
            z-index: 3;
          }

          &:nth-last-child(2) {
            z-index: 2;
          }

          &:last-child {
            z-index: 1;
          }
        }

        .avatar-img {
          border: 2px solid #fff;
        }

        .avatar-img-placeholder {
          border: 1px dashed #fff;
          background: repeating-linear-gradient(110deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.5) 1%, #ffd025 1%, #ffd025, 15%, rgba(255, 255, 255, 0.5) 15%);
        }
      }

      .group-info {
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0;
        color: #fff;

        .group-status {
          display: inline-block;
          margin-bottom: 3px;
          padding: 2px 5px 3px;
          text-align: center;
          border-radius: 4px;
          background: #ffaf0e;
        }
      }
    }

    .card-body {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      height: 60px;
      background: #fff;
    }

    .btn-join-group {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 120px;
      height: 38px;
      text-align: center;
      font-size: 16px;
      line-height: 19px;
      color: var(--txt-color-link);
      border-radius: 19px;
      background: var(--txt-color-link3);

      span {
        flex-shrink: 0;
      }

      .icon-container {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: var(--txt-color-link);

        .iconfont {
          line-height: 20px;
          color: #fff;
        }
      }
    }

    .count-down-container {
      .count-down-template {
        display: flex;
        align-items: center;

        .timer-unit-item {
          flex-shrink: 0;
          position: relative;
          width: 24px;
          height: 35px;
          font-size: 16px;
          text-align: center;

          .timer-value {
            margin-bottom: 2px;
            height: 21px;
            font-size: 18px;
            line-height: 21px;
            color: var(--txt-color-link);
          }

          .unit-tag {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 12px;
            color: #793d00;
            background: var(--txt-color-link3);

            span {
              display: block;
              text-align: center;
              transform: scale(0.5);
            }
          }

          &:first-child {
            .unit-tag {
              border-radius: 2px 0 0 2px;
            }
          }

          &:last-child {
            .unit-tag {
              border-radius: 0 2px 2px 0;
            }
          }
        }

        .colon-symbol {
          position: relative;
          flex-shrink: 0;
          width: 15px;
          height: 35px;

          &::before,
          &::after {
            content: '';
            position: absolute;
            left: 6px;
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background: var(--txt-color-link);
          }

          &::before {
            top: 7px;
          }

          &::after {
            top: 12px;
          }

          .placeholder-bg {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 12px;
            background: var(--txt-color-link3);
          }
        }
      }
    }
  }

  .group-buy-instruction-wrapper {
    .promotions-detail {
      position: relative;
    }

    .promotions-detail .step-guide-item {
      display: inline-flex;
      align-items: center;
      margin-bottom: 10px;

      &::before {
        content: '';
        display: inline-block;
        margin-right: 3px;
        width: 10px;
        height: 10px;
      }

      &:first-child::before {
        background: center/100% url('~assets/images/group-buy-activity/group-buy-step-1.png');
      }

      &:first-child::after,
      &:nth-child(2)::after {
        content: '';
        display: inline-block;
        margin: 0 8px;
        width: 18px;
        height: 16px;
        background: center/100% url('~assets/images/group-buy-activity/arrow-normal.png');
      }

      &:nth-child(2)::before {
        background: center/100% url('~assets/images/group-buy-activity/group-buy-step-2.png');
      }

      &:nth-child(3)::before {
        background: center/100% url('~assets/images/group-buy-activity/group-buy-step-3.png');
      }
    }

    .group-buy-tip-text {
      margin-top: 2px;
      color: var(--txt-color-lv2);
    }
  }
}
</style>
